(function () {
  'use strict';

  // Toggle this to true if you prefer transform: scale() zoom instead of background-image zoom.
  var USE_SCALE_ZOOM = true;

  // ADDED: enforce a minimum spinner visibility
  var MIN_LOADING_MS = 400;

  function $(root, sel) { return root.querySelector(sel); }
  function $all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  document.addEventListener('DOMContentLoaded', function () {
    $all(document, '[data-carousel-root]').forEach(initCarousel);
  });

  function initCarousel(root) {
    var stage = $(root, '[data-stage]');
    var stageImg = $(root, '[data-stage-img]');
    var thumbs = $all(root, '[data-thumb]');
    var stageContainer = $(root, '.atd-carousel__stage'); // ADDED: container for loading class/ARIA
    if (!stage || !stageImg || !thumbs.length || !stageContainer) return;

    if (USE_SCALE_ZOOM) stage.classList.add('use-scale');

    var active = thumbs[0];
    // ADDED: preload & set with loading state on first image to keep behavior consistent
    setStage(active.dataset.main, active.dataset.large, stage, stageImg, stageContainer);

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn === active) return;
        active.classList.remove('is-active');
        active.setAttribute('aria-pressed', 'false');
        active = btn;
        active.classList.add('is-active');
        active.setAttribute('aria-pressed', 'true');

        // ADDED: show loading until the new image is decoded/loaded
        setStage(btn.dataset.main, btn.dataset.large, stage, stageImg, stageContainer);

        btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
    });

    // Hover / touch zoom
    var isPointerInside = false;

    stage.addEventListener('mouseenter', function () {
      isPointerInside = true;
      stage.classList.add('is-zoomed');
      if (USE_SCALE_ZOOM) stageImg.style.willChange = 'transform';
    });

    stage.addEventListener('mousemove', function (e) {
      if (!isPointerInside) return;
      var rect = stage.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;

      if (USE_SCALE_ZOOM) {
        stageImg.style.transformOrigin = x + '% ' + y + '%';
      } else {
        stage.style.backgroundPosition = x + '% ' + y + '%';
      }
    });

    ['mouseleave', 'touchend', 'touchcancel'].forEach(function (ev) {
      stage.addEventListener(ev, function () {
        isPointerInside = false;
        stage.classList.remove('is-zoomed');
        if (USE_SCALE_ZOOM) {
          stageImg.style.transform = '';
          stageImg.style.transformOrigin = 'center';
          stageImg.style.willChange = '';
        } else {
          stage.style.backgroundPosition = 'center';
        }
      });
    });

    stage.addEventListener('touchstart', function (e) {
      stage.classList.toggle('is-zoomed');
      if (USE_SCALE_ZOOM) {
        var t = e.touches && e.touches[0];
        if (t) {
          var rect = stage.getBoundingClientRect();
          var x = ((t.clientX - rect.left) / rect.width) * 100;
          var y = ((t.clientY - rect.top) / rect.height) * 100;
          stageImg.style.transformOrigin = x + '% ' + y + '%';
        }
      } else {
        var t2 = e.touches && e.touches[0];
        if (t2) {
          var rect2 = stage.getBoundingClientRect();
          var x2 = ((t2.clientX - rect2.left) / rect2.width) * 100;
          var y2 = ((t2.clientY - rect2.top) / rect2.height) * 100;
          stage.style.backgroundPosition = x2 + '% ' + y2 + '%';
        }
      }
    }, { passive: true });

    // UPDATED: preload & decode before swapping; toggle loading state on container
    function setStage(urlMain, urlLarge, stageEl, imgEl, containerEl) {
      containerEl.classList.add('is-loading');
      containerEl.setAttribute('aria-busy', 'true');

      var newImg = new Image();
      newImg.decoding = 'async';
      var settled = false;

      // ADDED: start time to ensure minimum spinner duration
      var startTime = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();

      function finalize() {
        // swap image now that it's ready (or failed—still swap to avoid stale state)
        imgEl.src = urlMain;

        if (!USE_SCALE_ZOOM) {
          stageEl.style.setProperty('--bg', 'url("' + urlLarge + '")');
        }
        stageEl.classList.remove('is-zoomed');
        stageEl.style.backgroundPosition = 'center';

        containerEl.classList.remove('is-loading');
        containerEl.setAttribute('aria-busy', 'false');
      }

      function done() {
        if (settled) return;
        settled = true;

        // ADDED: enforce MIN_LOADING_MS spinner visibility
        var now = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
        var elapsed = now - startTime;
        var remaining = MIN_LOADING_MS - elapsed;

        if (remaining > 0) {
          setTimeout(finalize, remaining);
        } else {
          finalize();
        }
      }

      newImg.onload = done;
      newImg.onerror = done;
      newImg.src = urlMain;

      // decode() is supported on modern browsers; use it to avoid layout jank
      if (typeof newImg.decode === 'function') {
        newImg.decode().then(done).catch(done);
      }
    }
  }
})();
